import { useState, useEffect } from 'react';
import { Tooltip, Menu, MenuItem, Chip } from '@mui/material';
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import NameCardService from '@Helpers/URLHelpers/WeboutService/NameCardService';
import ErrorHandler from '@Root/ErrorHandler';

export default function UserUnsubscribe(props) {

    const [nameCard, setNameCard] = useState(null);
    const [cursor, setCursor] = useState('auto');
    const nameCardService = new NameCardService();
    const errorHandler = new ErrorHandler();

    useEffect(()=>{
        renderData();
    },[]);

    const renderData = async()=> {
        try {
            if(!props.nameCard) {
                await fetchNameCard(props?.id);
            } else {
                setNameCard(props.nameCard);
            }
        } catch(err) {
            errorHandler.handleError(err);
        }
    }

    const fetchNameCard = async (id) => {
        try {
            let response = await nameCardService.getById(id);
            response = JSON.parse(response.body);
            setNameCard(response);
        } catch(err) {
            errorHandler.handleError(err);
        }
    };

    const toggleSubscribe = async ()=> {
        setCursor('wait');
        try {
            let body = {
                id: nameCard?.id
            };
            let response = await nameCardService.toggleSubscribe(body);
            if(response.status < 400) {
                response = JSON.parse(response.body);
                setNameCard(response);
            }
        } catch(err) {
            errorHandler.handleError(err);
        }
        setCursor('auto');
    }

    const isSubscribed = nameCard?.isSubscribed;

    return (
        <Tooltip title={isSubscribed ? "Click to unsubscribe" : "Click to subscribe"}>
             <Chip
                 size="small"
                 clickable
                 onClick={toggleSubscribe}
                 disabled={cursor === 'wait'}
                 icon={
                     isSubscribed ? (
                         <CheckCircleIcon sx={{ fontSize: 18 }} />
                     ) : (
                         <CancelIcon sx={{ fontSize: 18 }} />
                     )
                 }
                 label={isSubscribed ? "Subscribed" : "Unsubscribed"}
                 sx={{
                     fontWeight: 500,
                     borderRadius: "8px",
                     px: 1,
                     transition: "all 0.2s ease",
                     backgroundColor: isSubscribed ? "#e6f4ea" : "#fdecea",
                     color: isSubscribed ? "#1e7e34" : "#b02a37",
                     "&:hover": {
                         backgroundColor: isSubscribed ? "#c8e6c9" : "#f8d7da",
                         transform: "scale(1.05)"
                     }
                 }}
             />
        </Tooltip>
    )
}